
function isInvalid (name: string, value: any) {
  if (!value) {
    console?.error(`缺少 ${name} 字段！`);
    return true;
  }
  return false;
}

function _is(x: any, y: any) {
  return (
    (x === y && (x !== 0 || 1 / x === 1 / y)) || (x !== x && y !== y) // eslint-disable-line no-self-compare
  );
}

const is: (x: any, y: any) => boolean = typeof Object.is === 'function' ? Object.is : _is;

// 格式化 memo 缓存的 key 值
function memoKey (key: string) {
  return `_$${key}$_`;
}

function areHookInputsEqual(
  nextDeps: Array<any>,
  prevDeps: Array<any> | null,
) {

  if (prevDeps === null) {
    return false;
  }

  for (let i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (is(nextDeps[i], prevDeps[i])) {
      continue;
    }
    return false;
  }
  return true;
}

/**
 * Class 组件中用于缓存数据，并且根据依赖列表是否变化，来判断是否返回缓存数据
 * @param variable 缓存数据的标识 - 同一个 Class 组件内禁止重复
 * @param target class中的this实例
 * @param creator 数据构建函数，返回需要缓存的数据
 * @param depts 依赖列表，用于判断数据是否需要重现创建
 */
 export default function classUseMemo<T> (variable: string, target: any, creator: () => T, deps?: any[]): T {

  if (isInvalid('variable', variable) || isInvalid('target', target) || isInvalid('creator', creator)) {
    throw new Error('useClassMemo 执行异常！');
  }

  const key = memoKey(variable); // 获取缓存的 key 值
 
  const nextDeps = deps === undefined ? null : deps;
  const prevState = target[key];
  if (prevState !== null && prevState !== undefined) {
    if (nextDeps !== null) {
      const prevDeps: Array<any> | null = prevState[1];
      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }
  const nextValue = creator();
  target[key] = [nextValue, nextDeps];
  return nextValue;
}
